/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import type { PostApiBarberShiftPause200, PostApiBarberShiftPause400, PostApiBarberShiftPause401, PostApiBarberShiftPause403, PostApiBarberShiftPause404, PostApiBarberShiftPause500, PostApiBarberShiftPauseMutationRequest, PostApiBarberShiftPauseMutationResponse } from "../entities/PostApiBarberShiftPause";
import { modelsErrorResponseSchema } from "./models/errorResponseSchema";
import { modelsMessageResponseSchema } from "./models/messageResponseSchema";
import { modelsShiftPauseInputSchema } from "./models/shiftPauseInputSchema";
import { z } from "zod/v4";

/**
 * @description OK
 */
export const postApiBarberShiftPause200Schema = z.lazy(() => modelsMessageResponseSchema) as unknown as z.ZodType<PostApiBarberShiftPause200>

/**
 * @description Bad Request
 */
export const postApiBarberShiftPause400Schema = z.lazy(() => modelsErrorResponseSchema).describe("Standard error response") as unknown as z.ZodType<PostApiBarberShiftPause400>

/**
 * @description Unauthorized
 */
export const postApiBarberShiftPause401Schema = z.lazy(() => modelsErrorResponseSchema).describe("Standard error response") as unknown as z.ZodType<PostApiBarberShiftPause401>

/**
 * @description Forbidden
 */
export const postApiBarberShiftPause403Schema = z.lazy(() => modelsErrorResponseSchema).describe("Standard error response") as unknown as z.ZodType<PostApiBarberShiftPause403>

/**
 * @description Not Found
 */
export const postApiBarberShiftPause404Schema = z.lazy(() => modelsErrorResponseSchema).describe("Standard error response") as unknown as z.ZodType<PostApiBarberShiftPause404>

/**
 * @description Internal Server Error
 */
export const postApiBarberShiftPause500Schema = z.lazy(() => modelsErrorResponseSchema).describe("Standard error response") as unknown as z.ZodType<PostApiBarberShiftPause500>

/**
 * @description Параметры паузы
 */
export const postApiBarberShiftPauseMutationRequestSchema = z.lazy(() => modelsShiftPauseInputSchema) as unknown as z.ZodType<PostApiBarberShiftPauseMutationRequest>

export const postApiBarberShiftPauseMutationResponseSchema = z.lazy(() => postApiBarberShiftPause200Schema) as unknown as z.ZodType<PostApiBarberShiftPauseMutationResponse>